var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import RedirectToAuth from './RedirectToAuth';
var DEFAULT_CONTEXT = {
    signOut: function () { return undefined; },
    user: null,
    userManager: null,
};
var AuthenticatorContext = React.createContext(DEFAULT_CONTEXT);
var Authenticator = /** @class */ (function (_super) {
    __extends(Authenticator, _super);
    function Authenticator(props) {
        var _this = _super.call(this, props) || this;
        _this.userManager = props.userManager;
        _this.signinArgs = props.signinArgs || {};
        _this.storeUser = _this.storeUser.bind(_this);
        _this.state = {
            context: {
                signOut: _this.signOut,
                user: null,
                userManager: _this.userManager,
            },
            isFetchingUser: true,
        };
        return _this;
    }
    Authenticator.prototype.componentDidMount = function () {
        this.getUser();
    };
    Authenticator.prototype.getUser = function () {
        var _this = this;
        this.userManager
            .getUser()
            .then(function (user) { return _this.storeUser(user); })
            .catch(function () { return _this.setState({ isFetchingUser: false }); });
    };
    Authenticator.prototype.storeUser = function (user) {
        if (user) {
            this.setState(function (_a) {
                var context = _a.context;
                return ({
                    context: __assign(__assign({}, context), { user: user }),
                    isFetchingUser: false,
                });
            });
        }
        else {
            this.setState(function (_a) {
                var context = _a.context;
                return ({
                    context: __assign(__assign({}, context), { user: null }),
                    isFetchingUser: false,
                });
            });
        }
    };
    Authenticator.prototype.signOut = function () {
        this.userManager.removeUser();
        this.getUser();
    };
    Authenticator.prototype.isValid = function () {
        var user = this.state.context.user;
        if (user) {
            return !user.expired;
        }
        if (sessionStorage.getItem('authnToken')) {
            return true;
        }
    };
    Authenticator.prototype.render = function () {
        if (this.state.isFetchingUser) {
            return React.createElement("div", null, "fetching user");
        }
        var user = this.state.context.user;
        if (user && !user.expired) {
            return (React.createElement(AuthenticatorContext.Provider, { value: this.state.context }, this.props.children || null));
        }
        else if (sessionStorage.getItem('authnToken')) {
            return (React.createElement(React.Fragment, null, this.props.children || null));
        }
        else {
            return (React.createElement(RedirectToAuth, { userManager: this.userManager, onSilentSuccess: this.storeUser, signinArgs: this.signinArgs, onError: this.props.onError }));
        }
    };
    return Authenticator;
}(React.Component));
export { AuthenticatorContext, Authenticator };
